import React, { useEffect, useState } from "react";
import "./All_offers.css";
import Explore_btn from "../../common-components/common-buttons/explore-button/Explore_btn";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { getCoupons } from "../../../features/home/homeSlice";
import Common_title from "../../common-components/common-title/Common_title";

const All_offers = () => {
  const [copyStatus, setCopyStatus] = useState("Copy");
  const [showTooltip, setShowTooltip] = useState(false);
  const [code, setCode] = useState("");
  const is_signin = useSelector((state) => state.auth.is_signin);
  const user = useSelector((state) => state.user.userInfo);

  useEffect(() => {
    setCode(user?.refer_code);
  }, [code]);

  const [copiedId, setCopiedId] = useState(null);
  // const [copyStatus, setCopyStatus] = useState("Copy");

  const handleCopy = (id, textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopiedId(id);
      setCopyStatus("Copied");

      setTimeout(() => {
        setCopiedId(null);
        setCopyStatus("Copy");
      }, 1500);
    });
  };

  //   const handleCopy = (id) => {
  //     navigator.clipboard.writeText(code).then(() => {
  //       setCopyStatus("Copied");
  //       setShowTooltip(true);
  //       setTimeout(() => {
  //         setCopyStatus("Copy");
  //         setShowTooltip(false);
  //       }, 1500);
  //     });
  //   };

  const dispatch = useDispatch();
  const allCoupons = useSelector((state) => state.home.addCoupons);

  useEffect(() => {
    dispatch(getCoupons());
  }, [dispatch]);

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };
  const groupedCoupons = Array.isArray(allCoupons?.data)
    ? chunkArray(allCoupons.data, 5)
    : [];

  return (
    <>
      <section className="All_offers_sec">
        <div className="container">
           <Common_title title="Offer Coupons" />
          <Swiper
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            spaceBetween={0}
            className="All_offers_sec_Swiper  pb-3"
          >
            {groupedCoupons?.map((val) => (
              <SwiperSlide>
                <div>
                  <div className="row me-0 ms-0">
                    <div className="col-md-3 col-sm-12 p-2">
                      <div className="leftsec">
                        {val[0] && (
                          <div className="bannerdiv bannerdiv_1 ">
                            <img
                              className="firstoffer"
                              src={
                                process.env.REACT_APP_IMAGE_URL + val[0]?.image
                              }
                              alt="firstoffer"
                            />

                            <div className="btnpos">
                              <div
                                className="codediv mb-1"
                                style={{ position: "relative" }}
                              >
                                <Form.Control
                                  type="search"
                                  placeholder="Enter Code"
                                  value={val[0]?.code}
                                  onChange={(e) => setCode(e.target.value)}
                                />
                                <button
                                  className="searchbtn"
                                  type="button"
                                  onClick={() =>
                                    handleCopy(val[0]?.id, val[0]?.code)
                                  }
                                  onMouseLeave={() => setCopiedId(null)}
                                  // onClick={handleCopy(val[0]?.id)}
                                  // onMouseLeave={() => setShowTooltip(false)}
                                >
                                  <img
                                    className="searchicn"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/bapat-benifits/copy.png"
                                    }
                                    alt="copy"
                                  />
                                  {copiedId === val[0]?.id && (
                                    <span
                                      style={{
                                        position: "absolute",
                                        top: "-30px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        background: "#333",
                                        color: "#fff",
                                        padding: "4px 10px",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        zIndex: 10,
                                      }}
                                    >
                                      {copyStatus}
                                    </span>
                                  )}
                                </button>
                              </div>

                              {/* <Explore_btn
                              name={"Explore Now"}
                              link={"/all-products"}
                            /> */}
                            </div>
                          </div>
                        )}
                        {val[1] && (
                          <div className="bannerdiv bannerdiv_2 ">
                            <img
                              className="secondoffer"
                              src={
                                process.env.REACT_APP_IMAGE_URL + val[1]?.image
                              }
                              alt="secondoffer"
                            />
                            <div className="btnpos">
                              <div
                                className="codediv mb-1"
                                style={{ position: "relative" }}
                              >
                                <Form.Control
                                  type="search"
                                  placeholder="Enter Code"
                                  value={val[1]?.code}
                                  onChange={(e) => setCode(e.target.value)}
                                />
                                <button
                                  className="searchbtn"
                                  type="button"
                                  onClick={() =>
                                    handleCopy(val[1]?.id, val[1]?.code)
                                  }
                                  onMouseLeave={() => setCopiedId(null)}
                                  //   onClick={handleCopy}
                                  //   onMouseLeave={() => setShowTooltip(false)}
                                >
                                  <img
                                    className="searchicn"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/bapat-benifits/copy.png"
                                    }
                                    alt="copy"
                                  />
                                  {copiedId === val[1]?.id && (
                                    <span
                                      style={{
                                        position: "absolute",
                                        top: "-30px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        background: "#333",
                                        color: "#fff",
                                        padding: "4px 10px",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        zIndex: 10,
                                      }}
                                    >
                                      {copyStatus}
                                    </span>
                                  )}
                                </button>
                              </div>
                              {/* <Explore_btn
                              name={"Explore Now"}
                              link={"/all-products"}
                            /> */}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12 p-2">
                      <div className="mid-sec">
                        {val[2] && (
                          <div className="bannerdiv ">
                            <img
                              className="thirdoffer"
                              src={
                                process.env.REACT_APP_IMAGE_URL + val[2]?.image
                              }
                              alt="thirdoffer"
                            />
                            <div className="btnpos">
                              <div
                                className="codediv mb-1"
                                style={{ position: "relative" }}
                              >
                                <Form.Control
                                  type="search"
                                  placeholder="Enter Code"
                                  value={val[2]?.code}
                                  onChange={(e) => setCode(e.target.value)}
                                />
                                <button
                                  className="searchbtn"
                                  type="button"
                                  onClick={() =>
                                    handleCopy(val[2]?.id, val[2]?.code)
                                  }
                                  onMouseLeave={() => setCopiedId(null)}
                                >
                                  <img
                                    className="searchicn"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/bapat-benifits/copy.png"
                                    }
                                    alt="copy"
                                  />
                                  {copiedId === val[2]?.id && (
                                    <span
                                      style={{
                                        position: "absolute",
                                        top: "-30px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        background: "#333",
                                        color: "#fff",
                                        padding: "4px 10px",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        zIndex: 10,
                                      }}
                                    >
                                      {copyStatus}
                                    </span>
                                  )}
                                </button>
                              </div>
                              {/* <Explore_btn
                              name={"Explore Now"}
                              link={"/all-products"}
                            /> */}
                            </div>
                          </div>
                        )}
                        {val[3] && (
                          <div className="bannerdiv ">
                            <img
                              className="thirdoffer"
                              src={
                                process.env.REACT_APP_IMAGE_URL + val[3]?.image
                              }
                              alt="thirdoffer"
                            />
                            <div className="btnpos">
                              <div
                                className="codediv mb-1"
                                style={{ position: "relative" }}
                              >
                                <Form.Control
                                  type="search"
                                  placeholder="Enter Code"
                                  value={val[3]?.code}
                                  onChange={(e) => setCode(e.target.value)}
                                />
                                <button
                                  className="searchbtn"
                                  type="button"
                                  onClick={() =>
                                    handleCopy(val[3]?.id, val[3]?.code)
                                  }
                                  onMouseLeave={() => setCopiedId(null)}
                                  //   onClick={handleCopy}
                                  //   onMouseLeave={() => setShowTooltip(false)}
                                >
                                  <img
                                    className="searchicn"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/bapat-benifits/copy.png"
                                    }
                                    alt="copy"
                                  />
                                  {copiedId === val[3]?.id && (
                                    <span
                                      style={{
                                        position: "absolute",
                                        top: "-30px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        background: "#333",
                                        color: "#fff",
                                        padding: "4px 10px",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        zIndex: 10,
                                      }}
                                    >
                                      {copyStatus}
                                    </span>
                                  )}
                                </button>
                              </div>
                              {/* <Explore_btn
                              name={"Explore Now"}
                              link={"/all-products"}
                            /> */}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {val[4] && (
                      <div className="col-md-3 col-sm-12 p-2">
                        <div className="right-sec">
                          <div className="bannerdiv ">
                            <img
                              className="fifthoffer"
                              src={
                                process.env.REACT_APP_IMAGE_URL + val[4]?.image
                              }
                              alt="fifthoffer"
                            />
                            <div className="btnpos">
                              <div
                                className="codediv mb-1"
                                style={{ position: "relative" }}
                              >
                                <Form.Control
                                  type="search"
                                  placeholder="Enter Code"
                                  value={val[4]?.code}
                                  onChange={(e) => setCode(e.target.value)}
                                />
                                <button
                                  className="searchbtn"
                                  type="button"
                                  onClick={() =>
                                    handleCopy(val[4]?.id, val[4]?.code)
                                  }
                                  onMouseLeave={() => setCopiedId(null)}
                                >
                                  <img
                                    className="searchicn"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/bapat-benifits/copy.png"
                                    }
                                    alt="copy"
                                  />
                                  {copiedId === val[4]?.id && (
                                    <span
                                      style={{
                                        position: "absolute",
                                        top: "-30px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        background: "#333",
                                        color: "#fff",
                                        padding: "4px 10px",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        zIndex: 10,
                                      }}
                                    >
                                      {copyStatus}
                                    </span>
                                  )}
                                </button>
                              </div>
                              {/* <Explore_btn
                              name={"Explore Now"}
                              link={"/all-products"}
                            /> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            ))}

            {/* <SwiperSlide>
                <div>
                  <div className="row">
                    <div className="col-md-3 col-sm-12 p-2">
                      <div className="leftsec">
                        <div className="bannerdiv ">
                          <img
                            className="firstoffer"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/offer/offer1.png"
                            }
                            alt="firstoffer"
                          />

                          <div className="btnpos">
                            <div
                              className="codediv mb-1"
                              style={{ position: "relative" }}
                            >
                              <Form.Control
                                type="search"
                                placeholder="Enter Code"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                              />
                              <button
                                className="searchbtn"
                                type="button"
                                onClick={handleCopy}
                                onMouseLeave={() => setShowTooltip(false)}
                              >
                                <img
                                  className="searchicn"
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/bapat-benifits/copy.png"
                                  }
                                  alt="copy"
                                />
                                {showTooltip && (
                                  <span
                                    style={{
                                      position: "absolute",
                                      top: "-30px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      background: "#333",
                                      color: "#fff",
                                      padding: "4px 10px",
                                      borderRadius: "4px",
                                      fontSize: "12px",
                                      whiteSpace: "nowrap",
                                      zIndex: 10,
                                    }}
                                  >
                                    {copyStatus}
                                  </span>
                                )}
                              </button>
                            </div>

                            <Explore_btn
                              name={"Explore Now"}
                              link={"/all-products"}
                            />
                          </div>
                        </div>
                        <div className="bannerdiv ">
                          <img
                            className="secondoffer"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/offer/offer2.png"
                            }
                            alt="secondoffer"
                          />
                          <div className="btnpos">
                            <div
                              className="codediv mb-1"
                              style={{ position: "relative" }}
                            >
                              <Form.Control
                                type="search"
                                placeholder="Enter Code"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                              />
                              <button
                                className="searchbtn"
                                type="button"
                                onClick={handleCopy}
                                onMouseLeave={() => setShowTooltip(false)}
                              >
                                <img
                                  className="searchicn"
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/bapat-benifits/copy.png"
                                  }
                                  alt="copy"
                                />
                                {showTooltip && (
                                  <span
                                    style={{
                                      position: "absolute",
                                      top: "-30px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      background: "#333",
                                      color: "#fff",
                                      padding: "4px 10px",
                                      borderRadius: "4px",
                                      fontSize: "12px",
                                      whiteSpace: "nowrap",
                                      zIndex: 10,
                                    }}
                                  >
                                    {copyStatus}
                                  </span>
                                )}
                              </button>
                            </div>
                            <Explore_btn
                              name={"Explore Now"}
                              link={"/all-products"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12 p-2">
                      <div className="mid-sec">
                        <div className="bannerdiv ">
                          <img
                            className="thirdoffer"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/offer/offer3.png"
                            }
                            alt="thirdoffer"
                          />
                          <div className="btnpos">
                            <div
                              className="codediv mb-1"
                              style={{ position: "relative" }}
                            >
                              <Form.Control
                                type="search"
                                placeholder="Enter Code"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                              />
                              <button
                                className="searchbtn"
                                type="button"
                                onClick={handleCopy}
                                onMouseLeave={() => setShowTooltip(false)}
                              >
                                <img
                                  className="searchicn"
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/bapat-benifits/copy.png"
                                  }
                                  alt="copy"
                                />
                                {showTooltip && (
                                  <span
                                    style={{
                                      position: "absolute",
                                      top: "-30px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      background: "#333",
                                      color: "#fff",
                                      padding: "4px 10px",
                                      borderRadius: "4px",
                                      fontSize: "12px",
                                      whiteSpace: "nowrap",
                                      zIndex: 10,
                                    }}
                                  >
                                    {copyStatus}
                                  </span>
                                )}
                              </button>
                            </div>
                            <Explore_btn
                              name={"Explore Now"}
                              link={"/all-products"}
                            />
                          </div>
                        </div>
                        <div className="bannerdiv ">
                          <img
                            className="thirdoffer"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/offer/offer4.png"
                            }
                            alt="thirdoffer"
                          />
                          <div className="btnpos">
                            <div
                              className="codediv mb-1"
                              style={{ position: "relative" }}
                            >
                              <Form.Control
                                type="search"
                                placeholder="Enter Code"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                              />
                              <button
                                className="searchbtn"
                                type="button"
                                onClick={handleCopy}
                                onMouseLeave={() => setShowTooltip(false)}
                              >
                                <img
                                  className="searchicn"
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/bapat-benifits/copy.png"
                                  }
                                  alt="copy"
                                />
                                {showTooltip && (
                                  <span
                                    style={{
                                      position: "absolute",
                                      top: "-30px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      background: "#333",
                                      color: "#fff",
                                      padding: "4px 10px",
                                      borderRadius: "4px",
                                      fontSize: "12px",
                                      whiteSpace: "nowrap",
                                      zIndex: 10,
                                    }}
                                  >
                                    {copyStatus}
                                  </span>
                                )}
                              </button>
                            </div>
                            <Explore_btn
                              name={"Explore Now"}
                              link={"/all-products"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-12 p-2">
                      <div className="right-sec">
                        <div className="bannerdiv ">
                          <img
                            className="fifthoffer"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/offer/offer5.png"
                            }
                            alt="fifthoffer"
                          />
                          <div className="btnpos">
                            <div
                              className="codediv mb-1"
                              style={{ position: "relative" }}
                            >
                              <Form.Control
                                type="search"
                                placeholder="Enter Code"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                              />
                              <button
                                className="searchbtn"
                                type="button"
                                onClick={handleCopy}
                                onMouseLeave={() => setShowTooltip(false)}
                              >
                                <img
                                  className="searchicn"
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/bapat-benifits/copy.png"
                                  }
                                  alt="copy"
                                />
                                {showTooltip && (
                                  <span
                                    style={{
                                      position: "absolute",
                                      top: "-30px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      background: "#333",
                                      color: "#fff",
                                      padding: "4px 10px",
                                      borderRadius: "4px",
                                      fontSize: "12px",
                                      whiteSpace: "nowrap",
                                      zIndex: 10,
                                    }}
                                  >
                                    {copyStatus}
                                  </span>
                                )}
                              </button>
                            </div>
                            <Explore_btn
                              name={"Explore Now"}
                              link={"/all-products"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide> */}
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default All_offers;
